import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';
import Loading from '../../components/Loading';
import Card from './form/Card.js';
import SplitRows from '../../components/general/SplitRow.js';
import OptionColumn from '../../components/general/OptionColumn.js';
import Notification from '../../components/Notification.js'
import moment from 'moment';
import LoadingSmall from '../../components/LoadingSmall.js';
import GeneralHandler from '../../modules/General';
import {setGlobalKey} from '../../actions/General';
import General from '../../modules/General';

class Settings extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			'isLoading':true,
			'accept_cancel':false,
			'isCancelling':false,
			'isResuming':false,


		}

		this.handleCancel = this.handleCancel.bind(this);
		this.handleCancleClick = this.handleCancleClick.bind(this);


	}

	handleResume() {
		this.setState({
			isResuming:true
		});
		axios.post('/subscriptions/resume').then(res => {
			GeneralHandler.fetchGeneral().then(res => {
				this.setState({
					isResuming:true
				});
			});
		});


	}

	handleCancel() {
        this.props.setGlobalKey('showProcessing',true);

        axios.post('/subscriptions/cancel').then(res => {
			GeneralHandler.fetchGeneral().then(res => {
				this.setState({
					accept_cancel:false,
				});

                Notification.success('Your account is now canceled');
                this.props.setGlobalKey('showProcessing',false);
                this.props.router.push(General.Link('/settings/billing'));

            });
		});
	}

	componentWillMount() {
		if(this.props.general.account.isOnGracePeriod) {
            this.props.router.push(General.Link('/settings/billing'));
        }
	}

	handleCancleClick(e) {
		this.setState({
			'accept_cancel':!this.state.accept_cancel
		});
	}

	render() {

		return (

				<div className="full-height">
				<div className="page-header">
					<span className="page-title"><i className="icon wb-payment"></i> Cancel</span>
				</div>

				<div className="page-content">

				<OptionColumn title="Cancel" description="Cancel your current subscription.">
					{this.props.general.account.grace_period ?
						<div>
							<p>Your subscription at crall will end at <strong>{moment(this.props.general.account.grace_period).format('DD.MM.YYYY')}</strong>, and will not be billed after this date.</p>
							{
								this.state.isResuming ?
								<LoadingSmall />
								:
								<button className="btn btn-success btn-block" onClick={(e) => {e.stopPropagation(); this.handleResume()}}>Resume subscription</button>
							}
						</div>
						:
					<div>
					<div className="col-sm-12">
						<div className="checkbox-custom checkbox-primary">
							<input type="checkbox" onChange={this.handleCancleClick} value={this.state.accept_cancel} />
							<label>Yes, i want to cancel my account.</label>
						</div>
					</div>
					{this.state.accept_cancel ?
						<div className="col-sm-12">

							{
								this.state.isCancelling ?
								<LoadingSmall />
								:
									<div>
										<button className="btn btn-danger btn-block" onClick={(e) => {e.stopPropagation(); this.handleCancel()}}>Cancel account</button>
									</div>
							}
						</div>
						:null}
					</div>
					}
				</OptionColumn>



				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		auth:state.auth,
		general:state.general,
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({setGlobalKey},dispatch)
}


Settings = connect(mapStateToProps,mapDispatchToProps)(Settings);
export default Settings;



// WEBPACK FOOTER //
// ./containers/settings/BillingCancel.js